import { default_limit, default_order } from "../config/defaults";


const UseLimit = (setState, value) => {
    return UseLocalStorage('limitItems', setState, value, default_limit)
}

const UseOrder = (setState, value) => {
    return UseLocalStorage('orderItems', setState, value, default_order)
}


const UseLocalStorage = (localStorageKey, stateFunction, currentValue, defaultValue) => {
    if(currentValue === undefined){
        return window.localStorage.getItem(localStorageKey) !== null ?
            window.localStorage.getItem(localStorageKey) :  defaultValue
    }else{
        window.localStorage.setItem(localStorageKey, currentValue)
        stateFunction(currentValue)
        return currentValue;
    }
}

export {UseLimit, UseOrder}